module.exports = __webpack_public_path__ + "img/21.bc4fe76b.jpg";